module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAQlBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8vt8POkxOQzgM3l6/HN3exzptpKjtGtyeYIx8TdAAAADXRSTlMA8Y0kTMy3rjMw5chRvQS2QgAAAItJREFUGNN1kVkWwyAIRcFoBg1ohu5/q02llJMc+n7Eq8ITQLSEhIQpLGAaJlJNg8IVyYSrwEh3xf4cHxQ/SUZ6agSYNWZmDWcIDg2QHJpAalUWVakHctr2DvcmW8iyntsFt5O+dwuJjosemtc8VK4/D+a3vZr5df/m98HvWce3/sb/s9C5lUy56NzehOURS4TeK5sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down2.png
// module id = 565V
// module chunks = 9